import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { isContactLensesSubscriptionLineItem } from '../../../utils/is-contact-lenses-subscription-line-item.js';
import { getSubscriptionLabels } from '../utils/get-subscription-labels.js';
import { Subtotal } from '../components/Subtotal.js';
import { MainTotal } from '../components/MainTotal.js';
import { SubscriptionExplainer } from '../components/SubscriptionExplainer.js';
import { SubscriptionType } from '../../../models/subscription/subscription-details.js';

const SubscriptionContainer = ({ lineItems , subscription , hideSubscriptionExplainer  })=>{
    const { currency , getLabel , getFormattedLabel  } = useIntl();
    const contactLensesSubscriptionLineItem = lineItems.find((lineItem)=>lineItem.type === 'contact-lenses-subscription'
    );
    const labels = React.useMemo(()=>({
            totalPerMonth: getLabel('cart.subscription.totalPerMonth'),
            totalPerThreeMonths: getLabel('cart.subscription.totalPerThreeMonths'),
            firstPayment: getLabel('cart.subscription.firstPayment'),
            subscriptionExplainer: {
                monthly: getFormattedLabel('cart.subscription.explainerMonthly', {
                    labelData: {
                        billingDate: subscription.billingDate
                    }
                }),
                quarterly: getFormattedLabel('cart.subscription.explainerQuarterly', {
                    labelData: {
                        billingDate: subscription.billingDate
                    }
                }),
                mixedMonthly: getFormattedLabel('cart.subscription.explainerMixedMonthly', {
                    labelData: {
                        billingDate: subscription.billingDate
                    }
                }),
                mixedQuarterly: getFormattedLabel('cart.subscription.explainerMixedQuarterly', {
                    labelData: {
                        billingDate: subscription.billingDate
                    }
                })
            }
        })
    , [
        getLabel,
        getFormattedLabel,
        subscription.billingDate
    ]);
    if (!contactLensesSubscriptionLineItem || !isContactLensesSubscriptionLineItem(contactLensesSubscriptionLineItem)) {
        return null;
    }
    const hasFirstPayment = contactLensesSubscriptionLineItem.subscriptionType === SubscriptionType.MIXED_MONTHLY;
    const { totals , explainer  } = getSubscriptionLabels(contactLensesSubscriptionLineItem.subscriptionType, labels);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, hasFirstPayment && /*#__PURE__*/ React.createElement(Subtotal, {
        label: labels.firstPayment,
        price: subscription.firstPayment,
        currency: currency
    }), /*#__PURE__*/ React.createElement(MainTotal, {
        label: totals,
        price: subscription.recurringPayment,
        currency: currency
    }), !hideSubscriptionExplainer && /*#__PURE__*/ React.createElement(SubscriptionExplainer, {
        information: explainer
    }));
};

export { SubscriptionContainer };
//# sourceMappingURL=SubscriptionContainer.js.map
